import React, { useState } from "react";
import { formatDate, formatDateTime } from "../../../algorithms/date";
import TotalRecords from "../total-records";
import NoDataFoundTemplate from "../no-data-found-template";
import { rowClassName } from "../../layout/package-status";
import { ScrollTop } from "primereact/scrolltop";

const MobileViewCards = ({ data, isSelectable = false }) => {
  console.log({ data });
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="md:hidden relative h-full">
      {/* Select All Bar */}
      {/* {showCheckboxes && (
        <div className="bg-white border-b px-4 py-3 flex gap-2 items-center">
          <button
            onClick={toggleSelectAll}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors border ${
              allPageSelected
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {allPageSelected ? "Deselect All" : "Select All"}
          </button>
          <span className="text-sm text-gray-600">on this page</span>
        </div>
      )} */}

      {/* total records */}
      <TotalRecords count={data.length} />

      {/* Package Cards */}
      <div className="p-1 space-y-3 pb-2">
        {data.map((item) => (
          <div
            key={item.waybillNumber}
            className={`bg-white rounded-xl shadow-sm border overflow-hidden transition-all border-primary-primaryYellowLight`}
          >
            {/* Card Header */}
            <div className="p-4">
              <div className="flex items-start gap-3">
                {/* Checkbox */}
                {/* {showCheckboxes && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSelect(item);
                    }}
                    className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${
                      isSelected(item)
                        ? "bg-blue-600 border-blue-600"
                        : "border-gray-300 bg-white"
                    }`}
                  >
                    {isSelected(item) && (
                      <svg
                        className="w-3 h-3 text-white"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path d="M5 13l4 4L19 7"></path>
                      </svg>
                    )}
                  </button>
                )} */}

                {/* Content */}
                <div
                  className="flex-1 cursor-pointer"
                  onClick={() =>
                    setExpandedId(
                      expandedId === item.waybillNumber
                        ? null
                        : item.waybillNumber
                    )
                  }
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1 text-gray-900 ">
                        <i size={16} className=" pi pi-box" />
                        <span
                          className="text-sm font-semibold max-w-[200px] break-words"
                          onClick={() => {
                            if (isSelectable) {
                              window.open(
                                `/operator/admin/view-package-history/${item.packageId}/${item.userId}`,
                                "_blank"
                              );
                            }
                          }}
                        >
                          {item.waybillNumber}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="pi pi-map-marker " size={14} />
                        <span>{item.lockerName}</span>
                      </div>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      {/* "bg-blue-500  text-white text-xs font-medium px-3 py-1 rounded-full" */}
                      <span
                        className={`${rowClassName(
                          item.packageStateNo
                        )} text-secondary-purpleGray text-xs font-medium px-3 py-1 rounded-full`}
                      >
                        {item.packageStateNo}
                      </span>
                      {expandedId === item.waybillNumber ? (
                        <i
                          size={20}
                          className="text-gray-400 pi pi-chevron-up"
                        />
                      ) : (
                        <i
                          size={20}
                          className="text-gray-400 pi pi-chevron-down"
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
                    <span className="text-xs text-gray-500">
                      {/* {getRelativeTime(item.packageDate)} */}
                      Package Date:
                    </span>
                    <span className="text-xs text-gray-400">
                      {formatDateTime(item.packageDate)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Expanded Details */}
            {expandedId === item.waybillNumber && (
              <div className="border-t border-gray-100 bg-gray-50 p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">Courier Mobile</span>
                  <div className="flex items-center gap-2">
                    <span className=" text-sm font-medium">
                      {item.partnerAgentMobile}
                    </span>
                    <a
                      href={`tel:${item.partnerAgentMobile}`}
                      className="text-yellow-600 hover:text-yellow-700"
                    >
                      {/* <Phone size={18} /> */}
                    </a>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">
                    Recipient Mobile
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium">
                      {item.recipientMobile}
                    </span>
                    <a
                      href={`tel:${item.recipientMobile}`}
                      className="text-yellow-600 hover:text-yellow-700"
                    >
                      {/* <Phone size={18} /> */}
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {data.length === 0 && (
        <div className="text-center py-12">
          {/* <Package size={48} className="mx-auto text-gray-300 mb-3" /> */}
          <NoDataFoundTemplate />
        </div>
      )}
    </div>
  );
};

export default MobileViewCards;
